export enum DashboardTasksTableTabs {
  All = 'All',
  WatchList = 'Watch List',
  Deferred = 'Deferred',
}
